import {
	getWallets,
	addWallet,
	editWallet,
	deleteWallet,

	getWalletForms,
	addWalletForm,
	editWalletForm,
	deleteWalletForm,
} from '@/api'
//
export default {
	namespaced: true,

	state: {
		wallets: [],
		walletsForms: {}
	},

	mutations: {
		setWallets (state, wallets) {
			state.wallets = wallets
		},

		setWalletForms (state, { id, forms }) {
			state.walletsForms[id] = forms
		}
	},

	actions: {
		getWallets (store) {
			return getWallets()
				.then(response => {
					response.data.result.map(wallet => {
						store.dispatch('getWalletForms', wallet._id)
					})

					store.commit('setWallets', response.data.result)

					return response
				})
		},

		addWallet (store, data) {
			return addWallet(data)
			.then(response => {
				store.dispatch('getWallets')
				//
				return response
			})
		},

		editWallet (store, { id, wallet }) {
			return editWallet(id, wallet)
			.then(response => {
				store.dispatch('getWallets')
				//
				return response
			})
		},

		deleteWallet (store, id) {
			return deleteWallet(id)
			.then(response => {
				store.dispatch('getWallets')
				//
				return response
			})
		},

		getWalletForms (store, id) {
			return getWalletForms(id)
				.then(response => {
					store.commit('setWalletForms', { id, forms: response.data.result })
					//
					return response
				})
		},


		addWalletForm (store, { id, form }) {
			return addWalletForm(id, form)
				.then(response => {
					store.dispatch('getWallets')
					//
					return response
				})
		},

		editWalletForm (store, { id, formId, form }) {
			return editWalletForm(id, formId, form)
				.then(response => {
					store.dispatch('getWallets')
					//
					return response
				})
		},

		deleteWalletForm (store, { id, formId }) {
			return deleteWalletForm(id, formId)
				.then(response => {
					store.dispatch('getWallets')
					//
					return response
				})
		},

	}
}



// WEBPACK FOOTER //
// ./src/store/modules/wallets.js